import { BlockService } from '@blocksuite/block-std';
import { Slot } from '@blocksuite/global/utils';
import { buildPath } from '../_common/utils/query.js';
import { getViewportFromSessionCommand, saveViewportToSessionCommand, } from './commands/index.js';
import { TemplateJob } from './service/template.js';
export class SurfaceService extends BlockService {
    constructor() {
        super(...arguments);
        this.TemplateJob = TemplateJob;
        this.slots = {
            edgelessToolUpdated: new Slot(),
        };
    }
    mounted() {
        super.mounted();
        this.std.command
            .add('getViewportFromSession', getViewportFromSessionCommand)
            .add('saveViewportToSession', saveViewportToSessionCommand);
    }
    _getSurfaceView() {
        const [surface] = this.page.getBlockByFlavour('affine:surface');
        const view = this.std.view.viewFromPath('block', buildPath(surface));
        return view;
    }
    get currentTool() {
        const view = this._getSurfaceView();
        if (!view)
            return null;
        const { edgeless } = view;
        return edgeless.edgelessTool;
    }
    setNavigatorMode(on, mode) {
        const view = this._getSurfaceView();
        if (!view)
            return;
        const { edgeless } = view;
        if (on && edgeless.edgelessTool.type === 'frameNavigator')
            return;
        if (!on && edgeless.edgelessTool.type !== 'frameNavigator')
            return;
        if (on) {
            edgeless.tools.setEdgelessTool({ type: 'frameNavigator', mode });
        }
        else {
            edgeless.tools.setEdgelessTool({ type: 'default' });
        }
    }
}
//# sourceMappingURL=surface-service.js.map